import React from 'react';

const ProductCountCustomTooltip = ({ payload, label }) => {
	return (
		<div className="chart-qnt-box shadow-8dp">
			<p className="regular-12 gray_dark_01 pb-2 text-center">{label}</p>
			{payload.map((item, i) => {
				return (
					<div className="dot-and-name pb-1 d-flex align-items-center" key={`tooltip_item_${i}`}>
						<span className="dots" style={{ backgroundColor: item.fill }} />
						<span className="cate-name regular-12 gray_dark_02 weight-500">
							{item.name} : {item.value}
						</span>
					</div>
				);
			})}
		</div>
	);
};

export default ProductCountCustomTooltip;
